export default __webpack_public_path__ + "static/media/gear.d64449ed.svg";